import { useMutation } from "react-query";

async function updateStaffBonusColumn(data: {
  id: string;
  name: string;
  description: string;
}) {
  const response = await fetch(`/internal-api/employee/bonus/columns`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return response.json();
}

export default function useUpdateStaffBonusColumn() {
  return useMutation(updateStaffBonusColumn);
}
